import { render, staticRenderFns } from "./checkStudentNotice.vue?vue&type=template&id=eb2be336&scoped=true"
import script from "./checkStudentNotice.vue?vue&type=script&lang=js"
export * from "./checkStudentNotice.vue?vue&type=script&lang=js"
import style0 from "./checkStudentNotice.vue?vue&type=style&index=0&id=eb2be336&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb2be336",
  null
  
)

export default component.exports